import { useTranslation } from '../../common/i18n/useTranslation';
import { WbText } from '@workbench/react';
import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material';

const useStyles = makeStyles()((theme: Theme) => ({
    spacing: {
        marginBottom: theme.spacing(5),
    },
    tightSpacing: {
        marginBottom: theme.spacing(1.5),
    },
}));

function RegistrationApproved() {
    const translate = useTranslation();
    const { classes } = useStyles();

    return (
        <WbText size="m" className={classes.tightSpacing}>
            {translate('registratrion_already_approved')}
        </WbText>
    );
}

export default RegistrationApproved;
